import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function ProfitField({ value, onChange, currency, testid }) {
  return (
    <div className="space-y-1.5">
      <Label className="flex items-center gap-1.5">
        Profit <span className="font-normal text-xs" style={{ color: "var(--text-muted)" }}>(optional, internal)</span>
        <Lock className="h-3 w-3" style={{ color: "var(--text-muted)" }} aria-label="Not shown to members" />
      </Label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs font-semibold" style={{ color: "var(--text-muted)" }}
              data-testid={`${testid}-currency`}>{currency}</span>
        <Input type="number" min="0" step="0.01" inputMode="decimal" value={value} placeholder="0.00"
               onChange={(e) => onChange(e.target.value)} className="pl-14" data-testid={testid} />
      </div>
    </div>
  );
}

export const profitPayload = (v) => (v === "" || v == null || isNaN(parseFloat(v)) ? {} : { profit_amount: parseFloat(v) });
